import { FC, useState } from 'react';
import styles from './CustomerAlertsWorkSupport.module.scss';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { Popover } from '@mantine/core';
import { ReactComponent as KebabMenu } from './img/iconKebab.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconCopy } from './img/iconCopy.svg';
import moment from 'moment';

export const CustomerAlertsWorkSupport: FC<any> = ({
  alert,
  setShowModalCancelAlert,
  setShowModalCreateAlert,
  setInitialData,
  setCancelAlertId,
  setButtonCreateAlert,
}) => {
  const [menuOpened, setMenuOpened] = useState(false);

  const handleOpenAlertModal = () => {
    setInitialData(alert);
    setShowModalCreateAlert(true);
  };

  const handleMenuItemClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setInitialData(alert);
    setMenuOpened(false);
    setShowModalCreateAlert(true);
  };

  const handleMenuCancelClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setMenuOpened(false);
    setShowModalCancelAlert(true);
  };

  const isActive = !alert.end_at
    ? moment.utc().isSameOrAfter(moment.utc(alert.start_at))
    : moment
        .utc()
        .isBetween(moment.utc(alert.start_at), moment.utc(alert.end_at), null, '[)');

  return (
    <div
      className={styles.root}
      onClick={handleOpenAlertModal}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleOpenAlertModal()}
      style={{ background: isActive ? '#e1e6fe' : undefined }}>
      <p className={styles.root_text}>
        <span>{moment(alert.created_at).format('DD.MM.YYYY, HH:mm')}</span>
      </p>
      <p className={styles.root_text}>
        <span>
          {alert.start_at ? moment(alert.start_at).format('DD.MM.YYYY, HH:mm') : '--:--'}
        </span>
      </p>
      <p className={styles.root_text}>
        <span>
          {alert.end_at ? moment(alert.end_at).format('DD.MM.YYYY, HH:mm') : '--:--'}
        </span>
      </p>
      <TextWithTooltip content={alert.title} />
      <TextWithTooltip content={alert.text} />
      <div className={styles.menu}>
        <Popover
          width={220}
          position='bottom-end'
          radius='4px'
          opened={menuOpened}
          onChange={setMenuOpened}>
          <Popover.Target>
            <KebabMenu
              className={styles.kebabIcon}
              onClick={(e: any) => {
                e.stopPropagation();
                setMenuOpened((prev) => !prev);
              }}
            />
          </Popover.Target>
          <Popover.Dropdown
            p='4px 0'
            style={{
              borderRadius: '4px',
              boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
              border: 'none',
            }}>
            <div
              className={styles.menuItem}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuCancelClick(e);
                setCancelAlertId(alert.id);
              }}>
              <IconCancel />
              <span>Отменить</span>
            </div>
            <div
              className={styles.menuItem}
              onClick={(e) => {
                setButtonCreateAlert(true);
                e.stopPropagation();
                handleMenuItemClick(e);
              }}>
              <IconCopy />
              <span>Дублировать</span>
            </div>
          </Popover.Dropdown>
        </Popover>
      </div>
    </div>
  );
};
